// extracted by mini-css-extract-plugin
module.exports = {"title":"EmbedVideo_title__1T6eb","section":"EmbedVideo_section__3aYNa"};